// src/services/customerService.ts
import apiClient from './apiClient';
import { CustomerApiResponse, CustomerDetailApiResponse } from '../types/customer';
import { toLegacyListResponse } from '../utils/normalizePaginatedResponse';
import type { Customer } from '../types/customer';

export const getCustomers = async (
  page = 1,
  search = '',
  isActive = '',
  limit = 9
): Promise<CustomerApiResponse> => {
  try {
    const params: Record<string, string | number> = { page, limit };
    if (search) params.search = search;
    if (isActive) params.isActive = isActive;

    const response = await apiClient.get('customers', { params });
    return toLegacyListResponse<Customer, 'customers'>(response.data, 'customers');
  } catch (error) {
    console.error('Failed to fetch customers:', error);
    throw error;
  }
};

export const getCustomerById = async (id: string): Promise<CustomerDetailApiResponse> => {
  try {
    const response = await apiClient.get(`customers/${id}`);
    const body = response.data as Record<string, unknown>;
    const customer = body?.customer ?? body?.data ?? body;
    return { customer: customer as CustomerDetailApiResponse['customer'] };
  } catch (error) {
    console.error(`Failed to fetch customer with id ${id}:`, error);
    throw error;
  }
};
